<template lang="html">
    <div class="harvester-controller">
        <div class="model-row" @click="isExpanded = !isExpanded">
            <div style="color: gray;" :class="['expand-collapse-ico', 'fas', !isExpanded ? 'fa-caret-right' : 'fa-caret-up']"></div>
            <b style="padding-left: 5px;flex-grow:1;">{{ harvester.title }}</b>

            <div class="btn-hover-orange fas fa-location-dot" @click.stop="isolateTags(harvester)" title="Isolate tags"></div>
            <div class="btn-hover-orange fas fa-copy" @click.stop="createInspection(harvester)" title="Create Inspection"></div>
            <div class="btn-hover-orange fas fa-search" @click.stop="updateHarvester(harvester)" title="Update"></div>
            <input type="file" style="display:none;" ref="uploadExcelTags" id="uploadExcelTagsInput" @change="uploadTagsExcel"
                accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, .xlsm" />
            <div :class="['btn-hover-orange', 'fas', isDownloading ? 'fa-spinner spinning' : 'fa-download']" @click.stop="downloadTagsExcel()" title="Download Excel"></div>
            <div :class="['btn-hover-orange', 'fas', isUploading ? 'fa-spinner spinning' : 'fa-upload']" @click.stop="showExcelBrowse()" title="Upload Excel"></div>
            <!-- <div class="btn-hover-orange fas fa-print" @click.stop="populateGroupProperties(harvester)" title="Populate"></div> -->
            <div class="btn-hover-orange fas fa-camera-retro" @click.stop="addHarvesterImages(harvester)" title="Add harvester images"></div>
            <div class="btn-hover-orange" :class="isDeleting ? 'fas fa-spinner spinning' : 'btn-hover-orange fas fa-trash'" @click.stop="deleteHarvester(harvester)" title="Delete Harvester"></div>
        </div>

        <div class="info-grid-container" v-if="isExpanded">
            <ag-grid-vue 
                style="width: 100%; height: 310px;" 
                class="ag-theme-alpine"
                @gridReady="onGridReady($event)"
                rowSelection='multiple'
                pagination="true"
                paginationAutoPageSize=true
                :rowMultiSelectWithClick="true"
                :columnDefs="columnDefs"
                :defaultColDef="defaultColDef"
                :rowData="rowData" 
                :overlayLoadingTemplate="overlayLoadingTemplate"
                :getRowId="getRowId">
            </ag-grid-vue>
        </div>
    </div>
</template>
<script>
import { AgGridVue } from "ag-grid-vue";
import HttpService from '../../../utils/httpService';

import loadingIcon from '../../../images/hourglass.gif';

export default {
    name: "HarvesterInfoController",
    components: {
    AgGridVue
},
    props: {
        harvester: {
            type: Object,
            required: true,
        },
        search: {
            type: String,
            required: false,
            default: '',
        }
    },
    data() {
        return {
            overlayLoadingTemplate:
            `<img style="position:absolute;top:50%;left:50%;transform:translate(-50%, -50%) scale(0.1)" src="${loadingIcon}" aria-label="loading">`,
            showProgress: false,
            isExpanded: false,
            isUploading: false,
            isDownloading: false,
            isDeleting: false,
            isLoading: false,
            gridColumnApi: null,
            gridApi: null,
            rowData: [],
            columnDefs: [],
            defaultColDef: {
                flex: 1,
                editable: false,
                filter: false,
                sortable: true,
                floatingFilter: false,
                resizable: true,
                cellDataType: false,
                cellRenderer: (data) => {
                    return data.value ? data.value : '-';
                }
            },
        };
    },
    beforeMount() {
        this.columnDefs = [
            { 
                headerName: 'Tag No.', 
                field: 'name', 
                colId: 'name', 
                sortable: true, 
                filter: false, 
                resizable: true, 
                headerCheckboxSelection: true,
                headerCheckboxSelectionFilteredOnly: true,
                checkboxSelection: true, 
            },
            { headerName: 'Model Tag', field: 'modelTag', colId: 'modelTag', sortable: true, filter: false, resizable: true },
            { headerName: 'Match', field: 'modelTag', colId: 'match', sortable: true,
                resizable: false,
                headerClass: 'text-center',
                cellRenderer: (params) => {
                    if (params.value) {
                        return `<i class="fas fa-check" style="color:green;width: 100%;text-align: center;"></i>`;
                    } else {
                        return `<i class="fas fa-times" style="color:red;width: 100%;text-align: center;"></i>`;
                    }
                }
            },
        ];
    },
    mounted() {
        this.isLoading = true;
        HttpService.get({
            url: `api/harvester/getHarvesterTags`,
            params: {
                harvesterId: this.harvester.id,
            },
        }).then((response) => {
            this.rowData = response.data ?? [];
            this.performSearch();
        }).catch((error) => {
            console.error(error.message);
        }).finally(() => {
            this.isLoading = false;
            this.gridApi?.hideOverlay();
        });
    },
    methods: {
        getRowId(params) {
            return params.data.id;
        },
        onGridReady(params) {
            this.gridApi = params.api;
            this.gridColumnApi = params.columnApi;

            if (this.isLoading) {
                this.gridApi.showLoadingOverlay();
            } else {
                this.performSearch();
            }
        },
        getSelectionRows() {
            let result = this.gridApi?.getSelectedNodes()?.map((node) => node.data);

            if (!result?.length) {
                return this.rowData;
            }

            return result;
        },
        getSelectionIds() {
            let result = this.gridApi?.getSelectedNodes()?.map((node) => node.data.id);

            if (!result?.length) {
                return this.rowData.map(node => node.id);
            }

            return result;
        },
        updateHarvester(harvester) {
            this.$store.commit('SET_TAG_HARVESTER_INFO', {
                id: harvester.id,
                title: harvester.title,
                masterType: harvester.masterType,
                ...JSON.parse(harvester.metaData)
            });

            this.$store.state.showAddAutoTagsPopup = true;
        },
        createInspection() {
            this.$store.state.tagsToCreateInspection = this.getSelectionRows();
            this.$store.state.showCreateInspectionPopup = true;
        },
        deleteHarvester(harvester) {
            let selectedIds = this.getSelectionRows()?.map((node) => node.id) ?? [];
            let harvesterRowsLength = this.rowData.length;
            
            if (selectedIds.length === harvesterRowsLength) {
                this.$store.dispatch('confirm_Forge', {
                    message: `Are you sure you want to delete "${harvester.title}" harvester?`, callback: () => {
                        this.isDeleting = true;
                        HttpService.post({
                            url: `api/harvester/deleteHarvester/${harvester.id}`
                        }).then(() => {
                            this.$store.dispatch('showSuccessfulMessage', {
                                message: `Harvester "${harvester.title}" deleted successfully.`,
                                timeout: 2000
                            });

                            this.$store.dispatch('UPDATE_HARVESTED_NODES_IDS')
                                .then(this.$store.dispatch('FETCH_ADMIN_HARVESTERS'))
                                .catch((error) => { console.error(error.message) });
                        }).catch((error) => {
                            this.$store.dispatch('alert_Forge', {
                                message: `An Error occurred when deleting "${harvester.title}" harvester.`
                            });
                            console.error(error.message);
                        }).finally(() => {
                            this.isDeleting = false;
                        });
                    }
                });
            } else {
                this.$store.dispatch('confirm_Forge', {
                    message: `Are you sure you want to delete selected tags?`, callback: () => {
                        this.isDeleting = true;
                        HttpService.post({
                            url: `api/harvester/deleteHarvesterTags/${harvester.id}`,
                            data: selectedIds
                        }).then(() => {
                            this.$store.dispatch('showSuccessfulMessage', {
                                message: `Tags deleted successfully.`,
                                timeout: 2000
                            });

                            this.$store.dispatch('UPDATE_HARVESTED_NODES_IDS')
                                .then(this.$store.dispatch('FETCH_ADMIN_HARVESTERS'))
                                .catch((error) => { console.error(error.message) });

                            this.rowData = this.rowData.filter((node) => !selectedIds.includes(node.id));
                        }).catch((error) => {
                            this.$store.dispatch('alert_Forge', {
                                message: `An Error occurred when deleting tags.`
                            });
                            console.error(error.message);
                        }).finally(() => {
                            this.isDeleting = false;
                        });
                    }
                });
            }            
        },
        isolateTags() {
            if (this.showProgress) {
                this.$store.dispatch({ type: "alert_Forge", message: 'Please wait for the current process to finish.' });
                return;
            }

            const callback = () => {
                this.showProgress = false;
                let selectedNodesIds = this.getSelectionRows()?.flatMap(node => node.modelNodes.map(n => n.dbId));
                this.$store.state.forgeService.getMainExtension().isolateDbIds(selectedNodesIds);
            }

            this.showProgress = true;

            if (this.$store.state.viewer) {
                callback();
            } else {
                this.$store.dispatch({ type: "alert_Forge", message: 'Model is loading, please wait!' })
                this.$store.commit('SET_ADMIN_MODEL_GEOMETRY_LOADED_CALLBACK', callback);
                this.$emit('open_3d_viewer');
            }
        },
        showExcelBrowse() {
            if (this.isDownloading || this.isUploading) return;

            this.$refs.uploadExcelTags.click();

            this.isExpanded = !this.isExpanded;
        },
        uploadTagsExcel() {
            if (this.isUploading) return;

            let type = this.harvester.masterType.split(' ')[0].toLowerCase();

            this.isUploading = true;

            let file = this.$refs.uploadExcelTags.files[0];
            let formData = new FormData();
            formData.set('file', file);

            HttpService.post({
                url: `api/tags/${type}/importExcel/${this.assetId}?ignoreInsert=true`,
                data: formData,
                headers: {
                    'Content-Type': false,
                    'processData': false,
                },
            }).then(() => {
                this.$store.dispatch('showSuccessfulMessage', {
                    message: `Tags updated successfully.`,
                    timeout: 3000
                });
            }).catch(({ message }) => {
                console.error(message);
                this.$store.dispatch("alert_Forge", {
                    message: `An Error occurred when updating tags.`
                });
            }).finally(() => {
                this.isUploading = false;
                this.$refs.uploadExcelTags.value = "";
            });
        },
        downloadTagsExcel() {
            if (this.isDownloading) return;

            this.isDownloading = true;

            const link = document.createElement('a');
            link.setAttribute('download', `${this.harvester.title} tags.xlsm`);
            document.body.appendChild(link);

            HttpService.get({
                url: `api/harvester/exportExcel/${this.harvester.id}`,
                responseType: 'blob',
            }).then((response) => {
                let blob = response.data;
                const objectUrl = URL.createObjectURL(blob);
                link.setAttribute('href', objectUrl);
                link.click();
                URL.revokeObjectURL(objectUrl);
            }).catch(({ message }) => {
                console.error(message);
                this.$store.dispatch("alert_Forge", {
                    message: `Failed to download tags file`,
                });
            }).finally(() => {
                document.body.removeChild(link);
                this.isDownloading = false;
            });
        },
        addHarvesterImages() {
            if (this.showProgress) {
                this.$store.dispatch({ type: "alert_Forge", message: 'Please wait for the current process to finish.' });
                return;
            }

            this.$store.dispatch("GET_HARVESTER_TAGS_NEEDS_IMAGES_IDS",
                {
                    harvestersIds: [this.harvester.id]
                }).then((tags) => {
                    if (tags.length == 0) {
                        this.$store.dispatch({ type: "alert_Forge", message: 'No tags found!' });
                        return;
                    }

                    let callback = () => {
                        console.log(`Start capturing thumbnail to harvester ${this.harvester.title}`);
                        this.showProgress = false;
                        this.$store.commit('SET_FILLING_HARVESTER_TAGS_THUMBNAILS', true);
                        this.$store.commit('SET_HARVESTER_TAGS_TO_CAPTURE', tags);
                    }

                    this.showProgress = true;

                    if (this.$store.state.viewer) {
                        callback();
                    } else {
                        this.$store.dispatch({ type: "alert_Forge", message: 'Model is loading, please wait!' })
                        this.$store.commit('SET_ADMIN_MODEL_GEOMETRY_LOADED_CALLBACK', callback);
                        this.$emit('open_3d_viewer');
                    }

                }).catch((error) => {
                    console.error(error.message);
                });
        },
        performSearch() {
            this.gridApi?.setQuickFilter(this.search);
        }
    },
    computed: {
        assetId() {
            return this.$store.state.assetId;
        },        
    },
    watch: {
        search: {
            handler: function () {
                this.performSearch();
            },
            deep: true
        },
    },
}
</script>
<style lang="css">
.harvester-controller .model-row:hover {
    background-color: #f5f5f5;
}
.harvester-controller .grid-container {
    animation: none;
}
.harvester-controller {
    animation: none;
}

.fas.fa-spinner {
    pointer-events: none;
}
</style>